import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { VpInfoMenu } from '../../components';
import { copyToClipboard } from '../../../utils/copyToClipboard';
import { useVpSnackbar } from '../../hooks';
import { useForceDownload } from '../../../hooks';
import { showSocialShareModal } from '../../../redux/modules/share';
import { useMediaTableContext } from '../../../hooks/contexts';

const MENU_ITEMS = [
  {
    id: 'copy',
    label: 'Copy Link',
    icon: 'Copy'
  },
  {
    id: 'share',
    label: 'Share',
    icon: 'Share2'
  },
  {
    id: 'download',
    label: 'Download',
    icon: 'DownloadCloud'
  },
  {
    id: 'thumbnail',
    label: 'Customize Thumbnail',
    icon: 'Image'
  },
  {
    id: 'delete',
    label: 'Delete',
    icon: 'Trash2',
    variant: 'error'
  }
];

export const VpMediaInfoMenu = ({
  media,
  disableCustomizeThumbnail = false,
  _showSocialShareModal
}) => {
  const menuItems = disableCustomizeThumbnail
    ? MENU_ITEMS.filter((item) => item.id !== 'thumbnail')
    : MENU_ITEMS;

  const id = media?.mediaId || media?.attachmentId;
  const { addSnackbarInfo } = useVpSnackbar();
  const { forceDownload, isLoading } = useForceDownload();
  const { setSelectedEntity, setSelectedSubmissionId, setUpdatingThumbnail } =
    useMediaTableContext();

  const onSelect = (item) => {
    switch (item?.id) {
      case 'copy': {
        copyToClipboard(`${window?.location?.origin}/share/${media?.mediaRawPath}`);
        addSnackbarInfo({ message: 'Copied link to clipboard', title: '' });
        return;
      }
      case 'share': {
        // this is the description of the question, not the description of the video that the user can update
        //   so we want to blank this out so it doesn't show in the youtube description box
        _showSocialShareModal(null, { ...media, description: '' });
        setSelectedSubmissionId(null);
        return;
      }
      case 'download': {
        const mediaUrlSplit = media?.mediaUrl?.split('/');
        const fileName = mediaUrlSplit[mediaUrlSplit.length - 1];
        forceDownload(media?.mediaUrl, fileName);
        return;
      }
      case 'thumbnail': {
        setUpdatingThumbnail(id);
        return;
      }
      case 'delete': {
        setSelectedEntity(media);
        return;
      }
    }
  };

  return <VpInfoMenu id={id} loading={isLoading} menuItems={menuItems} onSelect={onSelect} />;
};

VpMediaInfoMenu.propTypes = {
  _showSocialShareModal: PropTypes.func,
  media: PropTypes.object,
  disableCustomizeThumbnail: PropTypes.bool
};

const mapDispatchToProps = {
  _showSocialShareModal: showSocialShareModal
};

export default connect(null, mapDispatchToProps)(VpMediaInfoMenu);



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaInfoMenu.jsx